/** @format */

import React, { FunctionComponent, useEffect, useState } from 'react';
import GridContainer from '../../components/Grid/GridContainer';
import SimCardInterface from '../../interfaces/platform/SimCardInterface';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import I18n from '../../components/Translate/I18n';
import GridItem from '../../components/Grid/GridItem';
import ActionButton from '../../components/Buttons/CustomTextButton';
import AlertInfo from '../../components/Info/AlertInfo';
import CustomInputExt from '../../components/CustomInput/CustomInputExt';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { useDispatch } from 'react-redux';

type ChangeSPNType = {
    classes?: any;
    product: SimCardInterface;
    itemLoader?: ItemLoaders;
    refreshPage?: () => void;
};

export const ChangeSPN: FunctionComponent<ChangeSPNType> = ({ classes, product, itemLoader, refreshPage }) => {
    const dispatch = useDispatch();
    const [spnValue, setSpnValue] = useState<string | null>(null);
    const [reloadSpnValue, setReloadSpnValue] = useState(false);
    const [alertInfo, setAlertInfo] = useState<React.ReactElement | null>(null);

    const callReloadAccount = (): void => {
        const params = { id: product.id, activationType: 9, params: JSON.stringify({ name: 'SPN', value: spnValue }) };
        setSpnValue(null);
        setAlertInfo(null);
        if (!itemLoader) {
            itemLoader = new ItemLoaders(dispatch);
        }
        itemLoader.putWithCallback(
            FormGeneralHelper.getUrl('/operation_on_sim_cards/' + product.id),
            'product_reload_account',
            params,
            (): void => {
                if (refreshPage) {
                    refreshPage();
                }
            },
            { propagateDataToCallback: true }
        );
    };
    const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => setSpnValue(e.target.value);

    const setAlertInfoBox = (): void => {
        setAlertInfo(
            <AlertInfo
                onConfirm={callReloadAccount}
                onCancel={(): void => {
                    setAlertInfo(null);
                }}
                confirmBtnText={'simcard:f.save_change'}
                cancelBtnText={'general:common.cancel'}
                content="simcard:spn.confirm_change_spn"
                valueObject={{ amount: spnValue }}
                show={true}
                classes={classes}
            />
        );
    };

    useEffect((): void => {
        if (spnValue) {
            setReloadSpnValue(true);
        } else {
            setReloadSpnValue(false);
        }
    }, [spnValue]);

    return (
        <GridContainer>
            <GridItem xs={12}>
                <I18n trans="simcard:spn.spn_change" />
            </GridItem>
            <GridItem xs={12}>
                <CustomInputExt onChange={onChange} name="spnValue" onClick={(): void => {}} value={spnValue} labelText="simcard:spn.spn_new" />
            </GridItem>
            {reloadSpnValue && (
                <GridItem xs={12}>
                    <ActionButton size="sm" callback={setAlertInfoBox} callbackParam={{}} label="simcard:spn.spn_change_do" />
                </GridItem>
            )}
            {alertInfo}
        </GridContainer>
    );
};
